// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/framework7/dist/css/framework7.ios.colors.min.css
// module id = 790
// module chunks = 2